export const APP_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  ADD_BOOKING: '/add',
  USER_MANAGEMENT: '/users',
  CHANGE_PASSWORD: '/change-password',
  VIEW_BOOKING: (bookingId: number) => `/view/${bookingId}`,
  EDIT_BOOKING: (bookingId: number) => `/edit/${bookingId}`,
} as const;

export const APP_ROUTE_PATTERNS = {
  HOME: '/',
  LOGIN: '/login',
  ADD_BOOKING: '/add',
  USER_MANAGEMENT: '/users',
  CHANGE_PASSWORD: '/change-password',
  VIEW_BOOKING: '/view/:id',
  EDIT_BOOKING: '/edit/:id',
  FALLBACK: '*',
} as const;
